import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./data";

export const Header = () => (
    <header
        data-testid="site-header"
        className="sticky top-0 z-40 border-b border-[#D4AF37]/20 bg-[#FDFBF7]/80 backdrop-blur-xl"
    >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3.5">
            <a href="#home" data-testid="brand-logo" className="leading-tight">
                <span className="font-serif text-xl font-semibold tracking-tight text-[#2C2A29]">
                    Monisha <span className="text-[#D4AF37]">Makeover</span>
                </span>
                <span className="block text-[10px] font-semibold uppercase tracking-[0.25em] text-[#5A5652]">
                    Artistry · Chennai
                </span>
            </a>
            <a
                href={PHONE_TEL}
                data-testid="header-call-button"
                className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-5 py-2.5 text-sm font-bold text-[#2C2A29] shadow-md transition-transform duration-200 hover:-translate-y-0.5"
            >
                <Phone className="h-4 w-4" />
                <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
                <span className="sm:hidden">Call Now</span>
            </a>
        </div>
    </header>
);
